<script>
  import { onMount } from "svelte";
  import * as PropTypes from "prop-types";
  import SvgWrapper from "@/components/atoms/SvgWrapper.svelte";
  import SvgPlay from "$assets/svg/play.svg?src";
  import LazyImage from "@/components/molecules/LazyImage.svelte";
  import InfiniteScroll from "@/components/molecules/InfiniteScroll.svelte";
  import { _normalizeNumber } from "@/utils";
  import * as css from "@/utils/css";
  const { checkPropTypes, bool, func, string, array } = PropTypes;
  export let videos = [];
  export let hasMoreVideosData = true;
  export let fetchVideosData;
  export let fetchingVideosData;
  export let linkPrefix = "";
  let isMounted = false;

  const propTypes = {
    linkPrefix: string,
    videos: array,
    hasMoreVideosData: bool,
    fetchVideosData: func,
    fetchingVideosData: bool,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "Profile");
    isMounted = true;
  });
</script>

<div class="mb-7xl md:mb-13xl">
  <div class="flex flex-wrap -mx-0.5 md:mx-nxs" data-testid="grid-wrapper">
    {#each videos as video, i}
      <a
        href={`${linkPrefix}?start=${i}&referrer=web`}
        class="relative w-1/3 mb-xxs md:mb-md px-3xs md:px-xs"
        data-testid="feed-video"
      >
        <LazyImage
          src={video.b}
          alt={video.c}
          nw={360}
          nh={644}
          disabled={i < 9}
          objectFitClass="object-cover"
        />
        <div class={`${css.bottomAlign} h-1/5 bg-overlay`} />
        <div class="relative">
          <div
            class="absolute bottom-xxs md:bottom-sm right-xxs md:right-sm flex items-center"
          >
            <SvgWrapper className={`w-md h-md`} svg={SvgPlay} />
            <span class="pl-xs font-bold"
              >{_normalizeNumber(video.l, true)}</span
            >
          </div>
        </div>
      </a>
    {/each}
  </div>

  {#if isMounted}
    <InfiniteScroll
      elementScroll={window}
      elementOffset={document.documentElement}
      threshold={500}
      hasMore={hasMoreVideosData}
      isDarkTheme={true}
      loading={fetchingVideosData}
      dataTestIdLoader={"profile-grid-loader"}
      on:loadMore={() => fetchVideosData("concat")}
    />
  {/if}
</div>
